<div *ngIf="content$ | async as content" class="mr-xsmall-b pr-small-t font-body-1 font-body-medium">
  <a [finLink]="content.target.url" class="no-decoration nordic-blue-900-text text-icon-primary"
    ><fcom-icon
      class="back-link-icon nordic-blue-900-text text-icon-primary icon-small"
      [name]="SvgLibraryIcon.ARROW_LEFT"
    />
    {{ content.teaserTitle }}</a
  >
</div>
